import dayjs from 'dayjs';
import { isDamageDeleted } from '../features/inspections/utils/damageAnnotationUtils';
// import utc from 'dayjs/plugin/utc';

// dayjs.extend(utc);

export const dateFormatter = (value: string) => {
  return dayjs(value).format('MM/DD/YYYY HH:mm:ss');
};

export const transformHeatmap = (inspections: any[]) => {
  const partMap: any = {};
  const seen = new Set(); // prevent duplicate counting

  inspections?.forEach((inspection: any) => {
    inspection?.damages?.forEach((damage: any) => {
      if (isDamageDeleted(damage)) return;

      // skip if no AIAG data
      if (!damage?.aiagDamageArea?.code) return;

      // remove duplicate IDs
      if (seen.has(damage.id)) return;
      seen.add(damage.id);

      const partCode = damage.aiagDamageArea.code;
      const damageType = damage?.aiagDamageType?.description || 'Unknown';

      // create part bucket
      if (!partMap[partCode]) {
        partMap[partCode] = {
          part: partCode,
          items: {
            totalCount: 0,
            damages: {},
          },
        };
      }

      // increment total count
      partMap[partCode].items.totalCount++;

      // group damage type
      if (!partMap[partCode].items.damages[damageType]) {
        partMap[partCode].items.damages[damageType] = {
          damage: damageType,
          damage_count: 0,
        };
      }

      partMap[partCode].items.damages[damageType].damage_count++;
    });
  });

  // convert to array structure
  return Object.values(partMap).map((p: any) => ({
    part: p.part,

    items: {
      totalCount: p.items.totalCount,
      damages: Object.values(p.items.damages),
    },
  }));
};
